// extracted by mini-css-extract-plugin
export default {"chatGPT_container":"chatGPTCompiler_chatGPT_container__S9cBj"};